import type { EntitlementStatus } from '../services/entitlement/types';

export const FREE_SHEET_MAX = 3;

/** 課金済み Pro のみ。legacy は既存シートの閲覧用で、追加制限の免除には使わない */
export function isProEntitlement(entitlement: EntitlementStatus): boolean {
  return (
    entitlement.tier === 'pro' &&
    entitlement.source !== 'legacy'
  );
}

export function canAddSheet(sheetCount: number, entitlement: EntitlementStatus): boolean {
  if (isProEntitlement(entitlement)) return true;
  return sheetCount < FREE_SHEET_MAX;
}

export function freeSheetsRemaining(sheetCount: number, entitlement: EntitlementStatus): number {
  if (isProEntitlement(entitlement)) return Infinity;
  return Math.max(0, FREE_SHEET_MAX - sheetCount);
}
